import { HelpTypes } from '@pharmaplan/common';
import strings from '../../../../localization';

export const incompatibleDropdown = () =>
  [
    { key: HelpTypes.pharmacist, label: strings.pharmacist },
    { key: HelpTypes.technicians, label: strings.technician },
    { key: HelpTypes.students, label: strings.pharmacyStudent },
  ];
